module.exports = __webpack_public_path__ + "ptc_nakagawa_A2.8bc09b7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_A2.jpg
// module id = DXeL
// module chunks = 0